import type { ProfileTemplateContentDto } from '@up2stay/up2promo-api-client';

import { stylingToFormSlice } from '@/core/lib/profile-styling-form';
import { buildProfileStylingPayload } from '@/core/lib/profile-styling-form';

export function parseTemplateContent(raw: unknown): ProfileTemplateContentDto {
  if (!raw || typeof raw !== 'object') {
    return { modules: [] };
  }
  const c = raw as ProfileTemplateContentDto;
  const { integrations: _integrations, styling, ...rest } = c;
  const stylingSlice = stylingToFormSlice(styling);
  const hasStyling =
    Boolean(styling) ||
    stylingSlice.accentColor != null ||
    stylingSlice.headerImage != null;

  return {
    ...rest,
    modules: c.modules ?? [],
    ...(hasStyling || styling
      ? { styling: buildProfileStylingPayload(stylingSlice) }
      : {}),
  };
}

export function emptyTemplateContent(): ProfileTemplateContentDto {
  return { modules: [] };
}
